<template>
    <div class="pagination">
        <button class="button-back" :disabled="value === 1" @click.prevent="changePage(value - 1)">
            <i class="icon-chewron-down"></i>
        </button>
        <button
            v-for="(page, index) in pages"
            :key="index"
            :class="[page === value ? 'current-page' : 'page', page === '...' && 'empty-pagination']"
            :disabled="page === '...'"
            @click.prevent="changePage(page)"
        >
            {{ page }}
        </button>
        <button
            class="button-forward"
            :disabled="value === options.last_page"
            @click.prevent="changePage(value + 1)"
        >
            <i class="icon-chewron-down"></i>
        </button>
        <input
            v-if="options.last_page * options.per_page > options.per_page"
            v-model="current"
            v-numeric-only
            class="pagination-search"
            :placeholder="$t('common.goto')"
            @keyup.enter="changePageByInput(parseInt(current))"
        />
        <button class="icon-arrow-right goto" @click.prevent="changePageByInput(parseInt(current))"></button>
    </div>
</template>

<script type="text/babel">
import { OFFSET } from '../../constants';
import commonDirectives from './commonDirectives';

export default {
    mixins: [commonDirectives],

    props: {
        value: {
            type: Number,
            required: true,
        },

        options: {
            type: Object,
            required: true,
        },

        callback: {
            type: Function,
            required: true,
        },

        toCachePages: {
            type: Function,
            required: false,
            default: () => {},
        },

        unsavedCallback: {
            type: Function,
            required: false,
            default: () => {
                return Promise.resolve();
            },
        },
    },

    data() {
        return {
            current: undefined,
        };
    },

    computed: {
        /**
         * Forms pagination view
         * @return {[*, *]}
         */
        pages() {
            let pagination = [];
            let from = this.value - OFFSET;

            if (from <= 2) {
                from = 1;
            } else {
                pagination.push(1, '...');
            }

            let to = this.value + OFFSET;

            if (to >= this.options.last_page - 1) {
                to = this.options.last_page;
                while (from <= to) {
                    pagination.push(from);
                    from++;
                }
            } else {
                while (from <= to) {
                    pagination.push(from);
                    from++;
                }
                pagination.push('...', this.options.last_page);
            }

            let pages = pagination.filter(page => Number.isInteger(page));
            this.toCachePages(pages);

            return pagination;
        },
    },

    methods: {
        /**
         * Init callback function to change page view.
         * @param {int} page
         */
        changePage(page) {
            this.unsavedCallback()
                .then(() => {
                    this.$emit('input', page);
                    this.callback();
                })
                .catch(() => {});
        },

        /**
         * Init change page after click enter on keyboard or not if it's incorrect value
         * @param {int} page
         */
        changePageByInput(page) {
            if (page !== this.options.current_page) {
                if (page < 1) {
                    this.changePage(1);
                } else if (page > this.options.last_page) {
                    this.changePage(this.options.last_page);
                } else if (!isNaN(page)) {
                    this.changePage(page);
                }
            }
            this.$nextTick(() => {
                this.current = undefined;
            });
        },
    },
};
</script>
